import { LDClient, LDSingleKindContext } from 'launchdarkly-react-client-sdk';
import { DirectSignupFilters, ResumedLeadState } from '../context';
import { captureException } from '@sentry/react';
import { SignupError } from 'utils/errors/debuggableError';
import { LDContext } from 'utils/launchdarkly/launchdarkly';
import { TherapyTarget } from 'domains/signup/data/types';
import { merge } from 'lodash';

export const SIGNUP_LAUNCHDARKLY_EVENTS = {
  LANDING_PAGE_EXPERIMENT: {
    TRIGGERED: 'show_landing_page',
    SUBMITTED_EVALUATION: {
      ATTEMPT: 'evaluation_schedule_attempt',
      SUCCESS: 'evaluation_schedule_success',
      FAILURE: 'evaluation_schedule_failure',
    },
  },
  SCREENER_PROGRESS: {
    COMPLETED: 'screener_progress_completed',
  },
};

export const identifySignupLDUser = (
  LDClient: LDClient,
  filters: DirectSignupFilters,
  resumedLeadState?: ResumedLeadState,
) => {
  const currentCtx = LDClient.getContext();

  let newCtx = {};

  if ('kind' in currentCtx) {
    if (currentCtx.kind === LDContext.SCREENER_DEVICE) {
      newCtx = {
        key: currentCtx.key,
        screenerContext: {
          ...currentCtx,
        },
      };
    } else if (currentCtx.kind === LDContext.SIGNUP_DEVICE) {
      newCtx = currentCtx;
    }
  }

  newCtx = merge({}, newCtx, {
    kind: LDContext.SIGNUP_DEVICE,
    anonymous: true,

    stateCode: filters.stateCode,
    isAdult: filters.therapyTarget !== 'child',
    isInsurance: filters.paymentMethod.type === 'insurance',
    isPrivatePay: filters.paymentMethod.type === 'privatePay',
    isResumedLead: !!resumedLeadState,
    hasPrefilledAppointment: !!resumedLeadState?.prefilledAppointment,
    insurancePayerID: filters.paymentMethod.type === 'insurance' ? filters.paymentMethod.insuranceData.payerId : '',
    insuranceName: filters.paymentMethod.type === 'insurance' ? filters.paymentMethod.insuranceData.insuranceName : '',

    application: 'portal',
  });

  LDClient.identify(newCtx).catch(e => {
    captureException(
      new SignupError('Failed to identify user in LaunchDarkly', {
        debugData: {
          e,
        },
      }),
    );
  });
};

export const identifyScreenerLDUser = (
  LDClient: LDClient,
  screenerData: {
    age?: number;
    target?: TherapyTarget;
    isTherapyRecommended?: boolean;
  },
) => {
  const currentCtx = LDClient.getContext();

  let newCtx = {};

  if ('kind' in currentCtx && currentCtx.kind === LDContext.SCREENER_DEVICE) {
    newCtx = currentCtx;
  }

  newCtx = merge({}, newCtx, {
    kind: LDContext.SCREENER_DEVICE,
    anonymous: true,
    clientAge: screenerData.age,
    clientTarget: screenerData.target,
    isTherapyRecommended: screenerData.isTherapyRecommended,
    application: 'portal',
  } satisfies LDSingleKindContext);

  LDClient.identify(newCtx).catch(e => {
    captureException(
      new SignupError('Failed to identify user in LaunchDarkly', {
        debugData: {
          e,
        },
      }),
    );
  });
};
